import {
  CHECK_ELASTIC_LEADS,
  CUSTOMER_SOURCE_WALK_IN_CODE,
} from "app/appConfig";
import { LIST_GENDER, PAGESIZE_ALL } from "app/common/LocalConst";
import {
  convertDataLead,
  getCurrentStaff,
  getSourceCustomerCompanionCode,
  normalizeDataForServer,
} from "app/common/LocalFunction";
import { CheckIn } from "app/common/Model/CheckIn";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import {
  pagingElasticLeads,
  pagingElasticPatient,
} from "app/services/ElasticPatient";
import { pagingLead } from "app/services/LeadCRMService";
import localStorageService from "app/services/localStorageService";
import {
  cancleCheckIn,
  cancleCheckOut,
  checkCompanions,
  checkIn,
  CheckOut,
  exportExcelCheckinList,
  getCheckinById,
  pagingCheckIn,
  pagingReceptionEncounter,
} from "app/services/ReceptionService";
import { searchCheckInHistory } from "app/services/ESCheckInHistoryService";
import { pagingVisitType } from "app/services/VisitTypeService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
const DEFAULT_VALUE_CHECKOUT = {
  departmentId: null,
  visitDate: new Date(),
};
const DEFAULT_VALUE = {
  patient: {
    gender: LIST_GENDER[1].value,
  },
  issueDate: new Date(),
};
export default class CheckInListStore {
  searchCheckIn = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    hasBill: null,
    hasRevenue: null,
    hasDebt: null,
    hasAppointment: null,
    sourceId: null,
    sourceDetailId: null,
    sourceIds: [],
    sourceDetailIds: [],
    currentTelesaleIds: [],
  };

  initDataCheckIn = {
    ...DEFAULT_VALUE,
  };

  initDataCheckOut = {
    ...DEFAULT_VALUE_CHECKOUT,
  };

  searchDuplicatePatient = {
    ...new SearchObject(),
    phoneNumber: "",
    searchArchive: false,
  };

  openPopupSearchLead = false;
  pageCheckIn = new PageResponse();
  openFormCreateOrEdit = false;
  initialCheckIn = new CheckIn();
  openConfirmDelete = false;

  openCheckin = false;
  openPopupDuplicatePatient = false;
  openDupPatientByPhones = null;
  duplicatePatients = new PageResponse();
  openConfirmCheckIns = null;
  openConfirmHasAppointments = null;
  openConfirmError = null; //check khi chinh sua loi
  openConfirmDeleteError = null; //check khi xoa loi
  duplicatePatientSelected = null;
  openCheckInDependentPersonPopup = false;
  openDupPatientByPhonesDependentPopup = null;
  openPopupSearchDependentPersonLead = false;
  openConfirmHasAppointment = null;
  initCheckInDependentPerson = null;
  openPopupCheckDuplicateDependentPerson = false;
  listCompanionsSearchDuplicateIndex = new Set([]);
  customerSourceForCompanionDefault = null;
  openCheckout = false;

  openConfirmCheckOut = false;
  currentVisitIds = [];
  openCheckInHistoryElasticPopup = false;
  searchCheckInHistoryElastic = new SearchObject();
  pageCheckInHistoryElastic = new PageResponse();
  constructor() {
    makeAutoObservable(this);
  }
  handleOpenFormCreateOrEdit = async (checkIn) => {
    if (checkIn?.id) {
      getCheckinById(checkIn?.id).then(({ data }) => {
        this.initDataCheckIn = data;
        this.openCheckin = true;
      });
    } else {
      const visitType = await this.getVisitType();
      this.initDataCheckIn = {
        ...DEFAULT_VALUE,
        issueDate: new Date(),
        visitType,
      };
      this.openCheckin = true;
    }
  };

  setOpenCheckout = () => {
    this.openCheckout = true;
  };

  handleClosePopupCheckout = () => {
    this.openCheckout = false;
  };

  handleOpenCheckout = (obj, { setSubmitting }) => {
    return CheckOut(obj)
      .then(({ data }) => {
        this.openCheckout = false;
        toast.success(`Đã check out ${data} bản ghi`);
        this.pagingCheckIn();
        return data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Check out thông tin có lỗi");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  getVisitType = async () => {
    return await pagingVisitType({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      keyword: "offline_checkin",
    })
      .then(({ data }) => {
        if (data?.content?.length > 0) {
          return data?.content?.[0];
        }
        return null;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu loại check in có lỗi");
      });
  };

  setOpenConfirmCheckIns = (state) => {
    this.openConfirmCheckIns = state;
  };

  pagingCheckIn = async () => {
    let {
      listDepId,
      practitionerId,
      sourceId,
      sourceIds,
      sourceDetailId,
      sourceDetailIds,
      currentTelesaleIds,
      ...ortherData
    } = this.searchCheckIn;
    if (Array.isArray(listDepId) && listDepId.length > 0) {
      ortherData.listDepId = listDepId.map((x) => x?.id || x);
    } else if (listDepId && listDepId.id) {
      ortherData.listDepId = [listDepId.id];
    }
    if (practitionerId && practitionerId?.id) {
      ortherData.practitionerId = practitionerId?.id;
    }
    if (sourceId && sourceId?.id) {
      ortherData.sourceId = sourceId?.id;
    }
    if (sourceDetailId && sourceDetailId?.id) {
      ortherData.sourceDetailId = sourceDetailId?.id;
    }
    if (sourceIds && sourceIds.length > 0) {
      ortherData.sourceIds = sourceIds.map((item) => item.id);
    }
    if (sourceDetailIds && sourceDetailIds.length > 0) {
      ortherData.sourceDetailIds = sourceDetailIds.map((item) => item.id);
    }
    if (currentTelesaleIds && currentTelesaleIds.length > 0) {
      ortherData.currentTelesaleIds = currentTelesaleIds.map((item) => item.id);
    }
    let api = pagingCheckIn;
    const isPatientGeneral =
      window.location.pathname.includes("patient-general");

    if (isPatientGeneral) {
      api = pagingReceptionEncounter;
    }
    return await api({ ...ortherData })
      .then(({ data }) => {
        this.pageCheckIn = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu check in khách hàng có lỗi");
      });
  };

  handleChangeFormSearch = (searchCheckIn) => {
    this.searchCheckIn = { ...this.searchCheckIn, ...searchCheckIn };
    this.pagingCheckIn();
  };

  pagingCheckInHistoryElastic = async () => {
    try {
      const searchObj = {
        ...this.searchCheckInHistoryElastic,
        id: null,
        pageIndex: this.searchCheckInHistoryElastic.pageIndex || 1,
        pageSize: this.searchCheckInHistoryElastic.pageSize || 10,
      };
      const { data } = await searchCheckInHistory(searchObj);
      this.pageCheckInHistoryElastic = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu lịch sử check in có lỗi");
    }
  };

  handleOpenCheckInHistoryElastic = (rowData) => {
    this.searchCheckInHistoryElastic = {
      ...new SearchObject(),
      visitId: rowData?.visitId,
      pageIndex: 1,
      pageSize: 10,
    };
    this.pagingCheckInHistoryElastic();
    this.openCheckInHistoryElasticPopup = true;
  };

  handleCloseCheckInHistoryElastic = () => {
    this.openCheckInHistoryElasticPopup = false;
  };

  handleChangeFormSearchCheckInHistoryElastic = (searchObject) => {
    this.searchCheckInHistoryElastic = {
      ...this.searchCheckInHistoryElastic,
      ...searchObject,
    };
    this.pagingCheckInHistoryElastic();
  };

  setOpenConfirmCheckIn = (state) => {
    this.openFormCreateOrEdit = state;
  };

  handleCloseCheckinPopup = () => {
    this.openCheckin = false;
    this.duplicatePatientSelected = null;
    this.duplicatePatients = new PageResponse();
    this.initDataCheckIn = {
      ...DEFAULT_VALUE,
      issueDate: new Date(),
    };
  };
  setOpenConfirmHasAppointments = (state) => {
    this.openConfirmHasAppointment = state;
  };
  setOpenConfirmError = (state) => {
    this.openConfirmError = state;
  };

  setOpenConfirmDeleteError = (state) => {
    this.openConfirmDeleteError = state;
  };

  saveOrUpdateCheckin = async (obj, { setSubmitting }) => {
    try {
      let newObj = { ...obj };
      // tìm thấy kh trùng thì set patient
      if (this.duplicatePatientSelected?.id) {
        newObj.patient = {
          ...this.duplicatePatientSelected,
          phoneNumber: obj.patient.phoneNumber,
          displayName: obj.patient.displayName,
          gender: obj.patient.gender,
          birthDate: obj?.patient?.birthDate
            ? obj?.patient?.birthDate
            : this.duplicatePatientSelected?.birthDate,
        };
      }
      // nếu ko có patient thì sẽ là Khách vãng lại
      if (!newObj?.patient?.id) {
        newObj = {
          ...newObj,
          currentPatientSource: {
            ...(newObj.currentPatientSource || {}),
            code: CUSTOMER_SOURCE_WALK_IN_CODE,
          },
        };
      }

      // Thêm currentPatientSource và currentPatientSourceDetail vào visit nếu có visitId
      if (newObj.visitId) {
        newObj.visit = {
          id: newObj.visitId,
          currentPatientSource: newObj.currentPatientSource
            ? { id: newObj.currentPatientSource.id }
            : null,
          currentPatientSourceDetail: newObj.currentPatientSourceDetail
            ? { id: newObj.currentPatientSourceDetail.id }
            : null,
        };
      }

      const { data } = await checkIn(newObj);

      if (data?.responseStatus) {
        toast.success("Check in thông tin thành công!");
        this.pagingCheckIn();
        this.handleCloseCheckinPopup();
      } else if (data?.responseStatus === false && data?.hasAppointment) {
        this.openConfirmHasAppointment = {
          responseDetail: data?.responseDetail,
          appointmentId: data?.appointmentId,
        };
        return data?.responseStatus;
      } else if (data?.responseStatus === false) {
        if (data?.dupPatientByPhones?.length > 0) {
          //TH sau khi submit mà trùng dup phone
          this.duplicatePatients = data?.dupPatientByPhones;
          this.openDupPatientByPhones = {
            dataValue: newObj,
            responseDetail: data?.responseDetail,
          };
        }

        if (data?.checkedIn) {
          //checked in
          this.openConfirmCheckIns = data?.responseDetail;
        }

        return data?.responseStatus;
      }

      if (newObj?.isCompanions) {
        this.openCheckInDependentPersonPopup = true;
        await this.getCustomerSourceForCompanionDefault(
          data?.currentPatientSource?.platform
        );

        const patient = {
          phoneNumber: data?.patient?.phoneNumber,
          displayName: "",
          gender: LIST_GENDER[1].value,
        };

        this.initCheckInDependentPerson = {
          ...data,
          issueDate: new Date(),
          companions: [
            {
              patient,
              issueDate: new Date(),
              currentPatientSource: this.customerSourceForCompanionDefault,
            },
          ],
        };
      }
    } catch (error) {
      console.error(error);
      toast.error("Check in thông tin có lỗi");
    } finally {
      setSubmitting(false);
    }
  };

  getCustomerSourceForCompanionDefault = async (platform) => {
    // when create patient ,firstPatientSource or currentPatientSource not provided
    //set default source have code NKV_VL in system config
    let companyCode = getSourceCustomerCompanionCode();
    let { data } = await pagingCustomerSource({
      listCustomerSourceCode: companyCode,
      pageSize: PAGESIZE_ALL,
      pageIndex: 1,
    });
    if (platform) {
      let currentPatientSource = data?.content?.find(
        (el) => el?.platform === platform
      );

      this.customerSourceForCompanionDefault = currentPatientSource;
    }
  };

  saveCheckCompanions = async (obj, index) => {
    try {
      const { data } = await checkCompanions({
        ...obj,
        currentIndex: index,
      });
      const currentCompanions = data?.companions?.[index];
      if (data && currentCompanions?.responseStatus) {
        this.initCheckInDependentPerson = {
          ...data,
        };
        this.pagingCheckIn();
        toast.success("Check in thông tin thành công!");
      } else if (
        //  has appointment
        data &&
        currentCompanions?.responseStatus === false &&
        currentCompanions?.hasAppointment
      ) {
        this.openConfirmHasAppointment = {
          responseDetail: currentCompanions?.responseDetail,
          appointmentId: currentCompanions?.appointmentId,
          companionsIndex: data?.currentIndex,
        };
      } else if (data && currentCompanions?.responseStatus === false) {
        if (currentCompanions?.dupPatientByPhones?.length > 0) {
          //TH sau khi submit mà trùng dup phone
          this.duplicatePatients = currentCompanions?.dupPatientByPhones;
          this.openDupPatientByPhonesDependentPopup = {
            responseDetail: currentCompanions?.responseDetail,
            companionsIndex: data?.currentIndex,
            oldData: obj,
          };
        } else {
          this.openConfirmCheckIns = {
            responseDetail: currentCompanions?.responseDetail,
            companionsIndex: data?.currentIndex,
          };
        }
      }
    } catch (error) {
      toast.error(error);
    }
  };

  handleCloseCreateOrEditPopup = () => {
    this.openFormCreateOrEdit = false;
    this.duplicatePatients = new PageResponse();
    this.duplicatePatientSelected = null;
  };

  handleCloseCheckInDependentPersonPopup = () => {
    this.openCheckInDependentPersonPopup = false;
    this.duplicatePatientSelected = null;
    this.duplicatePatients = new PageResponse();
    this.listCompanionsSearchDuplicateIndex = new Set();
    this.customerSourceForCompanionDefault = null;
    this.searchDuplicatePatient = {
      ...new SearchObject(),
      phoneNumber: "",
      searchArchive: false,
    };
  };

  handleCloseConfirmDialog = () => {
    this.openConfirmDelete = false;
    this.initialCheckIn = new CheckIn();
  };

  handleDeleteCheckIn = (checkIn) => {
    this.initialCheckIn = { id: checkIn?.id };
    this.openConfirmDelete = true;
  };

  handleConfirmDeleteCheckIn = async () => {
    return await cancleCheckIn(this.initialCheckIn?.id)
      .then(({ data }) => {
        if (data?.responseStatus === false) {
          this.openConfirmDeleteError = data;
          // this.openConfirmDelete = false;
          return;
        }
        if (
          this.pageCheckIn?.pageIndex > 1 &&
          this.pageCheckIn?.content?.length === 1
        ) {
          this.pageCheckIn.pageIndex -= 1;
        }
        toast.success("Hủy check in thành công!");
        this.openConfirmDelete = false;
        this.pagingCheckIn();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
      });
  };

  handleCheckOut = (visitIds) => {
    this.currentVisitIds = Array.isArray(visitIds) ? visitIds : [visitIds];
    this.openConfirmCheckOut = true;
  };

  handleCloseConfirmDialogCheckOut = () => {
    this.openConfirmCheckOut = false;
    this.currentVisitIds = [];
  };

  handleConfirmCheckOut = async () => {
    if (!this.currentVisitIds?.length) return;
    try {
      await cancleCheckOut(this.currentVisitIds);
      toast.success("Checkout thành công!");
      this.openConfirmCheckOut = false;
      this.currentVisitIds = [];
      await this.pagingCheckIn();
    } catch (error) {
      console.error("handleConfirmCheckOut error:", error);
      toast.error("Đã có lỗi xảy ra, vui lòng thử lại!");
    }
  };

  searchLead = { ...new SearchObject(), pageSize: 10 };
  leadPatient = null;
  openSearchLead = false;
  handleSearchDuplicateInPersonal = async (obj) => {
    let { pageIndex, pageSize, ...ortherData } = obj;

    const newObj = {
      ...this.searchLead,
      pageIndex: pageIndex || this.searchLead?.pageIndex,
      pageSize: pageSize || this.searchLead?.pageSize,
      ...ortherData,
    };

    try {
      const { data } = await pagingLead({ ...newObj });
      if (data?.content?.length > 0) {
        this.searchLead = newObj;
        this.leadPatient = data;
        this.openSearchLead = true;
      }
      return data?.content || [];
    } catch (error) {
      console.error(error);
      // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  handleSearchLead = async () => {
    try {
      let { data } = await pagingLead({ ...this.searchLead });
      this.leadPatient = data;
      this.openSearchLead = true;
    } catch (error) {
      console.error(error);
      toast.error("Đã có lỗi xảy ra khi tìm lead vui lòng thử lại!");
    }
  };

  handleCloseSearchListPopup = () => {
    this.openSearchLead = false;
  };
  handleCheckPatient = async () => {
    try {
      let data = null;
      let dataApi = null;
      //gọi lead trước

      try {
        dataApi = await pagingLead({ ...this.searchDuplicatePatient });
      } catch (error) {
        console.error(error);
        // toast.error("Đã có lỗi xảy ra khi tìm lead vui lòng thử lại!");
      }

      if (dataApi?.data?.content?.length > 0) {
        this.duplicatePatients = dataApi?.data;
        this.openPopupSearchLead = true;
        data = dataApi?.data;
      } else {
        // ko có lead thì gọi api leads khác
        try {
          if (CHECK_ELASTIC_LEADS) {
            const elasticLeadResponse = await pagingElasticLeads({
              ...this.searchDuplicatePatient,
              searchArchive: false,

              keyword: this.searchDuplicatePatient?.phoneNumber,
            });
            if (elasticLeadResponse?.data?.content?.length > 0) {
              // Chuẩn hóa dữ liệu để xóa các trường date metadata
              const normalizedData = {
                ...elasticLeadResponse?.data,
                content: elasticLeadResponse?.data?.content?.map((item) =>
                  normalizeDataForServer(item, true)
                ),
              };
              this.duplicatePatients = normalizedData;
              this.openPopupSearchLead = true;
            } else {
              const patientResponse = await pagingElasticPatient({
                ...this.searchDuplicatePatient,
                keyword: this.searchDuplicatePatient?.phoneNumber,
              });

              if (patientResponse?.data?.content?.length > 0) {
                this.duplicatePatients = patientResponse?.data;
                this.openPopupDuplicatePatient = true;
                data = patientResponse?.data;
              } else {
                return [];
              }
            }
          } else {
            const patientResponse = await pagingElasticPatient({
              ...this.searchDuplicatePatient,
              keyword: this.searchDuplicatePatient?.phoneNumber,
            });

            if (patientResponse?.data?.content?.length > 0) {
              this.duplicatePatients = patientResponse?.data;
              this.openPopupDuplicatePatient = true;
              data = patientResponse?.data;
            } else {
              return [];
            }
          }
        } catch (err) {
          console.error("checkPatient cũng lỗi", err);
          // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
        }
      }
      // Luôn trả về mảng (nếu không có dữ liệu hoặc lỗi thì trả về mảng rỗng)
      return data?.content || [];
    } catch (error) {
      console.error(error);
      // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
      // Nếu có lỗi tổng, cũng coi như không tìm thấy dữ liệu để không chặn Checkin
      return [];
    }
  };

  // handleCheckPatient = async () => {
  //   try {
  //     const { data } = await checkPatient({ ...this.searchDuplicatePatient });

  //     if (data?.content?.length > 0) {
  //       this.duplicatePatients = data;
  //       this.openPopupDuplicatePatient = true;
  //     } else {
  //       const leadResponse = await pagingLead({
  //         // dùng chung biến search
  //         ...this.searchDuplicatePatient,
  //       });
  //       if (leadResponse?.data?.content?.length > 0) {
  //         this.duplicatePatients = leadResponse?.data;
  //         this.openPopupSearchLead = true;
  //       }
  //     }
  //     return data?.content;
  //   } catch (error) {
  //     console.error(error);
  //     toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
  //   }
  // };

  handleChangeFormSearchOnlyLeadDuplicate = (obj) => {
    let { pageIndex, pageSize, ...ortherData } = obj;
    this.searchDuplicatePatient = {
      ...this.searchDuplicatePatient,
      pageIndex: pageIndex || this.searchDuplicatePatient?.pageIndex,
      pageSize: pageSize || this.searchDuplicatePatient?.pageSize,
      ...ortherData,
    };

    const listPatient = this.handleCheckLead();
    return listPatient;
  };

  // Hàm chỉ tìm lead theo số điện thoại (không tìm patient)
  handleCheckLead = async () => {
    try {
      let dataApi = null;

      // Bước 1: Gọi API tìm kiếm lead
      try {
        dataApi = await pagingLead({ ...this.searchDuplicatePatient });

        if (dataApi?.data?.content?.length > 0) {
          // Chuẩn hóa dữ liệu để xóa các trường date metadata
          const normalizedData = {
            ...dataApi?.data,
            content: dataApi?.data?.content?.map((item) =>
              normalizeDataForServer(item, true)
            ),
          };
          this.duplicatePatients = normalizedData;
          // Giữ lại state form hiện tại (vd: currentTelesale) trong lúc mở popup chọn lead
          // Tránh trường hợp UI bị "mất giá trị" do rerender/enableReinitialize
          if (this.searchDuplicatePatient?.dataValue) {
            this.initDataCheckIn = {
              ...this.initDataCheckIn,
              ...this.searchDuplicatePatient.dataValue,
            };
          }
          this.openPopupSearchLead = true;
          return normalizedData?.content || [];
        }
      } catch (error) {
        console.error("Error pagingLead:", error);
      }

      // Bước 2: Nếu không có data từ pagingLead và CHECK_ELASTIC_LEADS = true, gọi API tìm lead elastic search
      if (CHECK_ELASTIC_LEADS) {
        try {
          dataApi = await pagingElasticLeads({
            ...this.searchDuplicatePatient,
            searchArchive: false,

            keyword: this.searchDuplicatePatient?.phoneNumber,
          });
          if (dataApi?.data?.content?.length > 0) {
            // Chuẩn hóa dữ liệu để xóa các trường date metadata
            const normalizedData = {
              ...dataApi?.data,
              content: dataApi?.data?.content?.map((item) =>
                normalizeDataForServer(item, true)
              ),
            };
            this.duplicatePatients = normalizedData;
            if (this.searchDuplicatePatient?.dataValue) {
              this.initDataCheckIn = {
                ...this.initDataCheckIn,
                ...this.searchDuplicatePatient.dataValue,
              };
            }
            this.openPopupSearchLead = true;
            return normalizedData?.content || [];
          }
        } catch (error) {
          console.error("Error pagingElasticLeads:", error);
        }
      }

      // Không tìm thấy lead
      return [];
    } catch (error) {
      console.error("Error handleSearchLeadOnly:", error);
      return [];
    }
  };

  handleChangeFormSearchDuplicate = (obj) => {
    let { pageIndex, pageSize, ...ortherData } = obj;
    this.searchDuplicatePatient = {
      ...this.searchDuplicatePatient,
      pageIndex: pageIndex || this.searchDuplicatePatient?.pageIndex,
      pageSize: pageSize || this.searchDuplicatePatient?.pageSize,
      ...ortherData,
    };

    const listPatient = this.handleCheckPatient();
    return listPatient;
  };

  handleChangeFormSearchDependentPerson = async (obj) => {
    let { pageIndex, pageSize, ...ortherData } = obj;
    this.searchDuplicatePatient = {
      ...this.searchDuplicatePatient,
      pageIndex: pageIndex || this.searchDuplicatePatient?.pageIndex,
      pageSize: pageSize || this.searchDuplicatePatient?.pageSize,
      ...ortherData,
    };

    const listPatient = await this.handCheckPatientDependentPerson();

    if (listPatient?.length > 0) {
      // nếu tìm thấy duplicate patient
      this.listCompanionsSearchDuplicateIndex.add(obj?.currentIndex);
    }
    return listPatient;
  };

  handleChangeFormSearchDependentOnlyLead = async (obj) => {
    let { pageIndex, pageSize, ...ortherData } = obj;
    this.searchDuplicatePatient = {
      ...this.searchDuplicatePatient,
      pageIndex: pageIndex || this.searchDuplicatePatient?.pageIndex,
      pageSize: pageSize || this.searchDuplicatePatient?.pageSize,
      ...ortherData,
    };

    const listPatient = await this.handCheckPatientDependentOnlyLead();

    if (listPatient?.length > 0) {
      // nếu tìm thấy duplicate patient
      this.listCompanionsSearchDuplicateIndex.add(obj?.currentIndex);
    }
    return listPatient;
  };

  handCheckPatientDependentOnlyLead = async () => {
    try {
      let dataApi = null;
      let data = null;
      try {
        dataApi = await pagingLead({ ...this.searchDuplicatePatient });
      } catch (error) {
        console.error(error);
      }

      if (dataApi?.data?.content?.length > 0) {
        this.duplicatePatients = dataApi?.data;
        this.openPopupSearchDependentPersonLead = true;
        data = dataApi?.data;
      } else {
        if (CHECK_ELASTIC_LEADS) {
          const elasticLeadResponse = await pagingElasticLeads({
            ...this.searchDuplicatePatient,
            searchArchive: false,

            keyword: this.searchDuplicatePatient?.phoneNumber,
          });
          if (elasticLeadResponse?.data?.content?.length > 0) {
            // Chuẩn hóa dữ liệu để xóa các trường date metadata
            const normalizedData = {
              ...elasticLeadResponse?.data,
              content: elasticLeadResponse?.data?.content?.map((item) =>
                normalizeDataForServer(item, true)
              ),
            };
            this.duplicatePatients = normalizedData;
            this.openPopupSearchDependentPersonLead = true;
            data = normalizedData;
          }
        }
      }

      return data?.content || [];
    } catch (error) {
      console.error(error);
      // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  handCheckPatientDependentPerson = async () => {
    try {
      let dataApi = null;
      let data = null;
      try {
        dataApi = await pagingLead({ ...this.searchDuplicatePatient });
      } catch (error) {
        console.error(error);
      }

      if (dataApi?.data?.content?.length > 0) {
        this.duplicatePatients = dataApi?.data;
        this.openPopupSearchDependentPersonLead = true;
        data = dataApi?.data;
      } else {
        if (CHECK_ELASTIC_LEADS) {
          const elasticLeadResponse = await pagingElasticLeads({
            ...this.searchDuplicatePatient,
            searchArchive: false,

            keyword: this.searchDuplicatePatient?.phoneNumber,
          });
          if (elasticLeadResponse?.data?.content?.length > 0) {
            // Chuẩn hóa dữ liệu để xóa các trường date metadata
            const normalizedData = {
              ...elasticLeadResponse?.data,
              content: elasticLeadResponse?.data?.content?.map((item) =>
                normalizeDataForServer(item, true)
              ),
            };
            this.duplicatePatients = normalizedData;
            this.openPopupSearchDependentPersonLead = true;
            data = normalizedData;
          } else {
            const patientResponse = await pagingElasticPatient({
              // dùng chung biến search
              ...this.searchDuplicatePatient,
              keyword: this.searchDuplicatePatient?.phoneNumber,
            });
            if (patientResponse?.data?.content?.length > 0) {
              this.duplicatePatients = patientResponse?.data;
              this.openPopupCheckDuplicateDependentPerson = true;
              data = patientResponse?.data;
            } else {
              return [];
            }
          }
        } else {
          const patientResponse = await pagingElasticPatient({
            // dùng chung biến search
            ...this.searchDuplicatePatient,
            keyword: this.searchDuplicatePatient?.phoneNumber,
          });
          if (patientResponse?.data?.content?.length > 0) {
            this.duplicatePatients = patientResponse?.data;
            this.openPopupCheckDuplicateDependentPerson = true;
            data = patientResponse?.data;
          } else {
            return [];
          }
        }
      }

      return data?.content;
    } catch (error) {
      console.error(error);
      // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  handleSelectDuplicatePatient = (patient) => {
    this.duplicatePatientSelected = patient;
    this.openPopupDuplicatePatient = false;
    this.openPopupSearchLead = false;

    this.initDataCheckIn = {
      ...DEFAULT_VALUE,
      ...this.searchDuplicatePatient?.dataValue,
      patient: {
        ...patient,
        phoneNumber: this.searchDuplicatePatient?.phoneNumber,
        displayName: patient?.fullName,
        gender: patient?.gender
          ? patient?.gender
          : this.searchDuplicatePatient?.dataValue?.patient?.gender,
      },
      issueDate: new Date(),
    };
  };

  handleSelectDupPatientByPhones = (patient) => {
    this.initDataCheckIn = {
      ...this.openDupPatientByPhones?.dataValue,
      patient: {
        ...this.openDupPatientByPhones?.dataValue?.patient,
        id: patient?.id,
        displayName: patient.displayName,
        gender: patient.gender,
        birthDate: patient?.birthDate
          ? patient?.birthDate
          : this.openDupPatientByPhones?.dataValue?.patient?.birthDate,
      },
    };
    this.openDupPatientByPhones = null;
  };

  handleSelectDuplicateDependentPerson = (patient) => {
    this.duplicatePatientSelected = patient;
    this.openPopupCheckDuplicateDependentPerson = false;
    const oldCompanions = this.searchDuplicatePatient?.oldData?.companions;
    const newCompanions = oldCompanions?.map((el, ind) => {
      if (this.searchDuplicatePatient?.currentIndex === ind) {
        return {
          ...el,
          patient: { ...patient, displayName: patient?.fullName },
        };
      } else return el;
    });
    this.initCheckInDependentPerson = {
      ...this.searchDuplicatePatient?.oldData,
      companions: newCompanions,
    };
  };

  handleSelectDupPatientByPhonesDependentPerson = (patient) => {
    const oldCompanions =
      this.openDupPatientByPhonesDependentPopup?.oldData?.companions;
    const newCompanions = oldCompanions?.map((el, ind) => {
      if (this.openDupPatientByPhonesDependentPopup?.companionsIndex === ind) {
        return {
          ...el,
          patient,
          // isMainPhoneNumber: patient?.isMainPhoneNumber,
        };
      } else return el;
    });
    this.openDupPatientByPhonesDependentPopup = null;

    this.initCheckInDependentPerson = {
      ...this.openDupPatientByPhonesDependentPopup?.oldData,
      companions: newCompanions,
    };
  };

  handleSelectLeadPatient = (patient) => {
    let convertPatient = convertDataLead(patient);
    this.duplicatePatientSelected = { ...convertPatient, isLead: true };
    this.openPopupDuplicatePatient = false;
    this.openPopupSearchLead = false;
    const oldDataValue = this.searchDuplicatePatient?.dataValue || {};
    const preservedVisitId = oldDataValue?.visitId || oldDataValue?.visit?.id;
    this.initDataCheckIn = {
      ...DEFAULT_VALUE,
      ...oldDataValue,
      ...(preservedVisitId ? { visitId: preservedVisitId } : {}),
      patient: {
        ...convertPatient,
        phoneNumber: this.searchDuplicatePatient?.phoneNumber,
      },
      leadId: patient?.id,
      lead: patient,
      marketingType: patient?.marketingType,
      // isMainPhoneNumber: true,
      issueDate: new Date(),
    };
  };

  handleSelectDependentPersonLeadPatient = (patient) => {
    let convertPatient = convertDataLead(patient);
    this.duplicatePatientSelected = { ...convertPatient, isLead: true };
    this.openPopupSearchDependentPersonLead = false;
    const oldCompanions = this.searchDuplicatePatient?.oldData?.companions;
    const newCompanions = oldCompanions?.map((el, ind) => {
      if (this.searchDuplicatePatient?.currentIndex === ind) {
        return {
          ...el,
          patient: convertPatient,
          leadId: patient?.id,
          lead: patient,
          marketingType: patient?.marketingType,

          // isMainPhoneNumber: true,
        };
      } else return el;
    });
    this.initCheckInDependentPerson = {
      ...this.searchDuplicatePatient?.oldData,
      companions: newCompanions,
    };
  };

  handleClosePopupDuplicatePatient = () => {
    this.openPopupDuplicatePatient = false;
  };

  handleCloseDupPatientByPhones = () => {
    this.openDupPatientByPhones = null;
  };

  handleClosePopupCheckDuplicateDependentPerson = () => {
    this.openPopupCheckDuplicateDependentPerson = null;
  };

  handleClosePopupPatientByPhonesDependent = () => {
    this.openDupPatientByPhonesDependentPopup = null;
  };

  handleClosePopupSearchLead = () => {
    this.openPopupSearchLead = false;
  };

  handleClosePopupSearchDependentPersonLead = () => {
    this.openPopupSearchDependentPersonLead = false;
  };

  handleExportExcelCheckInList = async (searchObj) => {
    this.searchCheckIn = { ...this.searchCheckIn, ...searchObj };
    let {
      listDepId,
      practitionerId,
      sourceId,
      sourceIds,
      sourceDetailId,
      sourceDetailIds,
      currentTelesaleIds,
      ...ortherData
    } = this.searchCheckIn;
    if (Array.isArray(listDepId) && listDepId.length > 0) {
      ortherData.listDepId = listDepId.map((x) => x?.id || x);
    } else if (listDepId && listDepId.id) {
      ortherData.listDepId = [listDepId.id];
    }
    if (practitionerId && practitionerId?.id) {
      ortherData.practitionerId = practitionerId?.id;
    }
    if (sourceId && sourceId?.id) {
      ortherData.sourceId = sourceId?.id;
    }
    if (sourceDetailId && sourceDetailId?.id) {
      ortherData.sourceDetailId = sourceDetailId?.id;
    }
    if (sourceIds && sourceIds.length > 0) {
      ortherData.sourceIds = sourceIds.map((item) => item.id);
    }
    if (sourceDetailIds && sourceDetailIds.length > 0) {
      ortherData.sourceDetailIds = sourceDetailIds.map((item) => item.id);
    }
    if (currentTelesaleIds && currentTelesaleIds.length > 0) {
      ortherData.currentTelesaleIds = currentTelesaleIds.map((item) => item.id);
    }
    try {
      const response = await exportExcelCheckinList({ ...ortherData });
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "DS_CHECK_IN.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } else {
        console.error("Export failed with status:", response.status);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  handleSelectLeadSelectLeadPersonal = (patient) => {
    let convertPatient = convertDataLead(patient);
    this.openSearchLead = false;
    const oldDataValue = this.searchLead?.dataValue || {};
    const preservedVisitId = oldDataValue?.visitId || oldDataValue?.visit?.id;

    this.initDataCheckIn = {
      patient: {
        ...convertPatient,
        phoneNumber: this.searchLead?.phoneNumber,
      },
      leadId: patient?.id,
      lead: patient,
      marketingType: patient?.marketingType,
      phoneNumber: this.searchLead?.phoneNumber,
      visitType: this.searchLead?.dataValue?.checkTypeVisit,
      receptionist: this.searchLead?.dataValue?.receptionist,
      issueDate: this.searchLead?.dataValue?.issueDate,
      department: this.searchLead?.dataValue?.department,
      ...(preservedVisitId ? { visitId: preservedVisitId } : {}),
    };
  };
  resetStore = () => {
    this.searchCheckIn = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
    };
    this.pageCheckIn = new PageResponse();
    this.openFormCreateOrEdit = false;
    this.initialCheckIn = null;
    this.openCheckin = null;
    this.openConfirmHasAppointment = null;
    this.checkIn = null;
    this.duplicatePatientSelected = null;
    this.openConfirmError = null;
    this.openConfirmDeleteError = null;
  };
  resetStoreDetail = () => {
    this.searchCheckIn = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
    };
    this.pageCheckIn = new PageResponse();
    this.openFormCreateOrEdit = false;
    this.initialCheckIn = null;
    this.checkIn = null;
    this.searchLeads = [];
    this.openPopupSearchLead = false;
    this.openConfirmError = null;
    this.openConfirmDeleteError = null;
  };
}
